export const valueToNull = <Type>(value: Type) => {
    if( typeof value ==="undefined")
    return null
    
    return value ? value : null
}